import { gql } from '@apollo/client';
import { ProductionOrderListInfo } from '../fragments';

export default gql`
  query productionOrders(
    $status: String
    $legacy: Boolean
    $patientId: ID
    $isPfg: Boolean
    $partnerLocationId: [ID!]
    $partnerOrganizationId: [ID!]
    $activeOnly: Boolean
    $manufacturerId: ID
    $states: [String!]
    $categories: [String!]
    $allStates: Boolean
    $createdAtStart: String
    $createdAtEnd: String
  ) {
    productionOrders(
      status: $status
      legacy: $legacy
      patientId: $patientId
      isPfg: $isPfg
      partnerLocationId: $partnerLocationId
      partnerOrganizationId: $partnerOrganizationId
      activeOnly: $activeOnly
      manufacturerId: $manufacturerId
      states: $states
      categories: $categories
      allStates: $allStates
      createdAtStart: $createdAtStart
      createdAtEnd: $createdAtEnd
    ) {
      ...ProductionOrderListInfo
    }
  }
  ${ProductionOrderListInfo}
`;
